import PropTypes from 'prop-types';

const Route = props => React.createElement(props.component, props.props);

Route.propTypes = {
  component: PropTypes.func.isRequired,
  props: PropTypes.object,
};

export default Route;
